import { STATES } from '../../constants';
import * as actions from '../../state/actions';
import './errors';

const template = `
  <upd-error-page>
  </upd-error-page>
`;

export function ErrorsConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.ERROR, {
    url: '/error',
    views: {
      '@': {
        template,
        controller: ($element, updStore) => {
          const errorsPage = $element.find('upd-error-page')[0];
          errorsPage.addEventListener('upd-error-page-events', event => {
            handleErrorPageEvent(event, updStore);
          });
          updStore.dispatch(actions.step.isTerminalRoute());
        },
      },
    },
    scrollTop: true,
    disableBreadcrumb: true,
    analytics: {
      page: 'Error',
    },
    data: {
      permissions: 'anyone',
    },
  });
}

function handleErrorPageEvent(event, store) {
  if (event.detail.retry && history.length > 2) {
    history.back();
  } else {
    store.dispatch(actions.router.stateGo(STATES.DASHBOARD));
  }
}
